import React, { useContext, useState, useEffect } from "react";
import { DateRange } from "react-date-range";
import { useDetectClickOutside } from "react-detect-click-outside";
import tr from "date-fns/locale/tr";
import format from "date-fns/format";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { Icon } from "../../icons/icons";
import { useRouter } from "next/router";
import { StoreContext } from "../../context/context";
import useLocale from "../../helper/useLocale";
import { useTranslation } from "../../context/TranslationContext";

const SliderFormDatepicker = ({
  className,
  label,
  form,
  setForm,
  start = new Date(),
  end = new Date().setDate(new Date().getDate() + 5),
  setParam,
}) => {
  const { currentRoutingTypeId } = useContext(StoreContext);
  const localeData = useLocale();
  const { close } = useTranslation();
  const router = useRouter();

  const [state2, setState2] = useState([
    {
      startDate: router.query.start
        ? new Date(router.query.start)
        : start
        ? new Date(start)
        : new Date(),
      endDate: router.query.end
        ? new Date(router.query.end)
        : end
        ? new Date(end)
        : end,
      key: "selection",
      isShow: 0,
    },
  ]);
  const [isShow, setIsShow] = useState(false);
  const [dayStart, setdayStart] = useState(format(state2[0].startDate, "dd"));
  const [dayEnd, setdayEnd] = useState(format(state2[0].endDate, "dd"));

  const [monthStart, setmonthStart] = useState(
    format(state2[0].startDate, "MMM", { locale: localeData })
  );
  const [monthEnd, setmonthEnd] = useState(
    format(state2[0].endDate, "MMM", { locale: localeData })
  );

  useEffect(() => {
    setdayStart(format(state2[0].startDate, "dd"));
    setdayEnd(format(state2[0].endDate, "dd"));
    setmonthStart(format(state2[0].startDate, "MMM", { locale: localeData }));
    setmonthEnd(format(state2[0].endDate, "MMM", { locale: localeData }));
  }, [state2, localeData]);

  function ToggleShow() {
    setIsShow(!isShow);
  }
  function CloseToggle() {
    setIsShow(false);
  }
  function onChange(item) {
    setState2([item.selection]);
    if (item.selection.startDate !== item.selection.endDate) {
      if (
        currentRoutingTypeId == "ProductSearch" ||
        currentRoutingTypeId == "ProductDestination" ||
        currentRoutingTypeId == "ProductCategory"
      ) {
        setParam({
          start: format(item.selection.startDate, "yyyy-MM-dd", {
            locale: localeData,
          }),
          end: format(item.selection.endDate, "yyyy-MM-dd", {
            locale: localeData,
          }),
          s: 1,
        });
      } else {
        form.start = format(item.selection.startDate, "yyyy-MM-dd", {
          locale: localeData,
        });
        form.end = format(item.selection.endDate, "yyyy-MM-dd", {
          locale: localeData,
        });
        setForm(form);
      }
      CloseToggle();
    }
  }

  const ref = useDetectClickOutside({ onTriggered: CloseToggle });

  return (
    <div className={className} ref={ref}>
      <div
        className={
          "flex lg:justify-start justify-between lg:flex-col items-center lg:items-stretch lg:px-6 border-b lg:border-0 lg:border-r border-brand-gray-3 cursor-pointer " +
          (currentRoutingTypeId == "Home"
            ? "gap-y-1 lg:pt-4 pb-2 "
            : "pb-4 lg:pb-0 lg:pt-1")
        }
        onClick={ToggleShow}
      >
        <label
          form="search_destination"
          className="text-tiny font-bold text-brand-gray-2"
        >
          {label}
        </label>
        <div className="flex content-center items-center justify-between w-28 lg:w-auto">
          <div className="text-brand-black-2 font-bold flex flex-col items-center">
            <span className="text-xl">{dayStart}</span>
            <small className="text-xs">{monthStart}</small>
          </div>
          <Icon name={"datepickerArrows"} className="w-7 lg:w-auto"></Icon>
          <div className="text-brand-black-2 font-bold flex flex-col items-center">
            <span className="text-xl">{dayEnd}</span>
            <small className="text-xs">{monthEnd}</small>
          </div>
        </div>
      </div>
      <div
        className={
          "fixed justify-between items-center flex-col top-0 h-full pb-16 lg:h-auto lg:absolute w-full lg:w-96 bg-white left-0 shadow-xl sm:p-4 border lg:top-full transition-transform transform-gpu z-[60] flex lg:origin-top " +
          (isShow ? "scale-1" : "scale-0")
        }
      >
        <div className=""></div>
        {isShow && (
          <>
            <DateRange
              editableDateInputs={false}
              onChange={(item) => onChange(item)}
              moveRangeOnFirstSelection={false}
              ranges={state2}
              showDateDisplay={false}
              locale={localeData}
              months={1}
              showMonthAndYearPickers={false}
              direction="horizontal"
            />
          </>
        )}
        <button
          className="bg-brand-black text-white px-2 py-2 self-end w-full"
          type="button"
          onClick={() => {
            CloseToggle();
          }}
        >
          {close}
        </button>
      </div>
    </div>
  );
};

export default SliderFormDatepicker;
